export const enum USER_BILL_TYPE {
   GUEST = 'guest',
   CUSTOMER = 'customer'
}